import { useEffect, type ReactNode } from 'react';
import { useThemeStore } from '@/store';

export function ThemeProvider({ children }: { children: ReactNode }) {
  const setTheme = useThemeStore((s) => s.setTheme);

  useEffect(() => {
    setTheme('light');
  }, [setTheme]);

  return <>{children}</>;
}
